import { MaskedLines, FadeUp } from "@/components/Reveal";

const SectionHeading = ({ eyebrow, titleLines, description, align = "left", id }) => {
  const centered = align === "center";
  return (
    <div className={`mb-14 max-w-3xl ${centered ? "mx-auto text-center" : ""}`} id={id}>
      {eyebrow && (
        <FadeUp>
          <p className="mb-4 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-corp-500" style={{ justifyContent: centered ? "center" : "flex-start" }}>
            <span className="inline-block h-px w-8 bg-corp-500" />
            {eyebrow}
          </p>
        </FadeUp>
      )}
      <MaskedLines
        as="h2"
        inView
        lines={titleLines}
        className="font-display text-4xl font-bold tracking-tight sm:text-5xl"
        lineClassName=""
      />
      {description && (
        <FadeUp delay={0.15}>
          <p className="mt-6 text-base leading-relaxed text-mist md:text-lg">{description}</p>
        </FadeUp>
      )}
    </div>
  );
};

export default SectionHeading;
